import { LIST_CLIENTS} from '../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case LIST_CLIENTS:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;